import { useQuery, UseQueryResult } from '@tanstack/react-query'

import moodsService from '@/core/api/services/moodsService'

export function useMoods({ config, options }: any = {}): UseQueryResult<
	string[],
	Error
> {
	const QUERY_KEY = [
		'moods',
		{
			...config?.params,
		},
	]

	return useQuery({
		queryKey: QUERY_KEY,
		queryFn: () =>
			moodsService.getMoods(config).then(({ data }) => {
				return data.data
			}),
		...options,
		cacheTime: 86400000, // 24h
		staleTime: 86400000, // 24h
	})
}
